import { useAssetPath } from './useAssetPath';

export const useAssetIconPath = (iconName: string): string => {
  return useAssetPath(`icons/${iconName}`);
};
